import Vue from 'vue'
import { mutationTypes } from './mutations'
import { mutationTypes as globalMutationTypes } from './../globals/mutations'

const actionTypes = {
  LOAD_CHILDREN: 'loadChildren',
  SUBMIT: 'submit'
}

const toAnswers = (items) =>
  items.filter((i) => !i.isLocked && i.status !== undefined).reduce((acc, curr) => ((acc[curr.cprNumber] = curr.status), acc), {})

const actions = {
  [actionTypes.LOAD_CHILDREN]: async ({ commit }) => {
    try {
      commit(mutationTypes.SET_LOADING, 'Vent et øjeblik...')
      const [passportResponse, drivingLicenseResponse] = await Promise.all([
        Vue.axios.get('verification'),
        Vue.axios.get('verification/driving-license')
      ])
      commit(mutationTypes.SET_CHILDREN, passportResponse.data)
      commit(mutationTypes.SET_DRIVING_LICENSE_CASES, drivingLicenseResponse.data)
    } catch {
      commit(`globals/${globalMutationTypes.SET_ERROR}`, null, { root: true })
    } finally {
      commit(mutationTypes.RESET_LOADING)
    }
  },
  [actionTypes.SUBMIT]: async ({ state, commit }) => {
    try {
      commit(mutationTypes.SET_LOADING, 'Vent et øjeblik...')

      const passportAnswers = toAnswers(state.children)
      const drivingLicenseAnswers = toAnswers(state.drivingLicenseCases)

      if (Object.keys(passportAnswers).length > 0) {
        await Vue.axios.post('verification', { cprNumberToAnswers: passportAnswers })
      }

      if (Object.keys(drivingLicenseAnswers).length > 0) {
        await Vue.axios.post('verification/driving-license', { cprNumberToAnswers: drivingLicenseAnswers })
      }

      commit(mutationTypes.LOCK_SUBMITTED)
    } catch {
      commit(`globals/${globalMutationTypes.SET_ERROR}`, null, { root: true })
    } finally {
      commit(mutationTypes.RESET_LOADING)
    }
  }
}

export { actionTypes }
export default actions
